/**
 * VAN-TOS Premium Theme JS
 * Ultra-fast Vanilla JS for Cart Drawer, Quick Add, and Interactive Components
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initFaqAccordion();
  initAjaxAddToCart();
});

// ----------------- Cart Drawer Controller -----------------
function initCartDrawer() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const openButtons = document.querySelectorAll('[data-cart-drawer-trigger]');
  const closeButtons = document.querySelectorAll('[data-cart-drawer-close]');

  if (!overlay) return;

  const openDrawer = () => {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  };

  const closeDrawer = () => {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  openButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));

  closeButtons.forEach(btn => btn.addEventListener('click', closeDrawer));

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeDrawer();
  });

  window.openVanTosCart = openDrawer;
  window.refreshVanTosCart = refreshCartDrawer;
}

// ----------------- Fetch & Render Cart Drawer -----------------
async function refreshCartDrawer() {
  const itemsContainer = document.querySelector('.drawer-items');
  const subtotalEl = document.querySelector('.drawer-subtotal-price');
  const cartCountBadges = document.querySelectorAll('.cart-count');

  if (!itemsContainer) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Actualizar contadores
    cartCountBadges.forEach(badge => {
      badge.textContent = cart.item_count;
    });

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div style="text-align: center; padding: 48px 16px;">
          <p style="font-size: 1rem; color: var(--color-text-muted); margin-bottom: 20px;">Tu cesta está vacía</p>
          <a href="/collections/all" class="btn-primary" style="padding: 12px 28px; font-size: 0.875rem;">Explorar Colección</a>
        </div>
      `;
      if (subtotalEl) subtotalEl.textContent = '0,00 €';
      return;
    }

    // Renderizar productos en el carrito
    const formattedSubtotal = (cart.total_price / 100).toLocaleString('es-ES', { style: 'currency', currency: cart.currency });
    if (subtotalEl) subtotalEl.textContent = formattedSubtotal;

    let itemsHtml = '';
    cart.items.forEach(item => {
      const itemPrice = (item.final_line_price / 100).toLocaleString('es-ES', { style: 'currency', currency: cart.currency });
      itemsHtml += `
        <div style="display: flex; gap: 16px; padding: 16px 0; border-bottom: 1px solid var(--color-border); align-items: center;">
          <img src="${item.image}" alt="${item.title}" style="width: 64px; height: 64px; object-fit: cover; border-radius: var(--radius-sm); border: 1px solid var(--color-border);" />
          <div style="flex-grow: 1;">
            <h4 style="font-size: 0.875rem; font-weight: 700; color: var(--color-primary); margin-bottom: 4px;">${item.product_title}</h4>
            <div style="display: flex; justify-content: space-between; align-items: center; font-size: 0.8125rem;">
              <span style="color: var(--color-text-muted);">Cant: ${item.quantity}</span>
              <strong style="color: var(--color-primary);">${itemPrice}</strong>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHtml;
  } catch (err) {
    console.error('Error al actualizar carrito:', err);
  }
}

// ----------------- Ajax Add to Cart -----------------
function initAjaxAddToCart() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('button');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Añadiendo...';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!res.ok) throw new Error('Error al añadir producto');

      if (window.openVanTosCart) {
        window.openVanTosCart();
      }
    } catch (err) {
      console.error(err);
      alert('Hubo un problema al añadir el producto al carrito.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    }
  });
}

// ----------------- FAQ Accordion -----------------
function initFaqAccordion() {
  const triggers = document.querySelectorAll('.faq-trigger');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq-item');
      const isActive = item.classList.contains('active');

      // Cerrar otros
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));

      if (!isActive) {
        item.classList.add('active');
      }
    });
  });
}
